import { Marked } from 'marked';
import { useMemo } from 'react';
import handbuchDe from '../../../../docs/handbuch.md?raw';
import handbookEn from '../../../../docs/handbook.md?raw';
import { useI18n } from '../i18n';

/** Überschrift → Sprungmarke (gleiche Regel für Inhaltsverzeichnis und Überschriften). */
export const slug = (s: string) => s.toLowerCase().replace(/<[^>]+>/g, '').replace(/[^a-z0-9äöüß]+/g, '-').replace(/^-|-$/g, '');

/**
 * Handbuch im Tool. Quelle sind docs/handbuch.md (Deutsch) und docs/handbook.md (Englisch) im Repo:
 * Wer eine Funktion ändert, passt im selben Pull Request das Handbuch an, und es erscheint mit dem nächsten Ausrollen hier.
 */
export function HelpPage() {
  const { t, lang } = useI18n();
  const src = lang === 'en' ? handbookEn : handbuchDe;
  const { html, toc } = useMemo(() => renderHandbook(src), [src]);
  return (
    <section className="page help">
      <div className="pagehead"><div><div className="crumb">{t('app.name')}</div><h1>{t('help.title')}</h1></div><span className="spacer" />
        <button className="btn" onClick={() => window.dispatchEvent(new CustomEvent('ft:tour'))}>{t('tour.restart')}</button>
        <button className="btn" onClick={() => window.dispatchEvent(new KeyboardEvent('keydown', { key: '?' }))}>{t('keys.title')}</button>
      </div>
      <div className="helpgrid">
        <nav className="box helptoc" aria-label={t('help.toc')}>
          <div className="lbl">{t('help.toc')}</div>
          <ol>{toc.map((h) => <li key={h.id}><a href={`#${h.id}`}>{h.text}</a></li>)}</ol>
        </nav>
        {/* Inhalt stammt aus dem Repo (kein Nutzereingang); HTML darin wird trotzdem nicht übernommen */}
        <article className="box helpbody" dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </section>
  );
}

export function renderHandbook(md: string): { html: string; toc: { id: string; text: string }[] } {
  const toc: { id: string; text: string }[] = [];
  const marked = new Marked({
    renderer: {
      heading({ tokens, depth }) {
        const text = this.parser.parseInline(tokens);
        const id = slug(text);
        if (depth === 2) toc.push({ id, text: text.replace(/<[^>]+>/g, '') });
        return depth === 1 ? '' : `<h${depth} id="${id}">${text}</h${depth}>`;
      },
      html({ text }) { return text.replace(/</g, '&lt;'); },
    },
  });
  const html = marked.parse(md, { async: false }) as string;
  return { html, toc };
}
